import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestion} from "@fortawesome/free-solid-svg-icons";
import React from "react";

export default function BrandLogo({brand, className, size = 8}) {
    let bg = brand['bg'] ?? 'bg-slate-300 dark:bg-slate-600';
    let text = brand['text'] ?? 'text-slate-800 dark:text-slate-100';

    let icon = null;

    if (typeof brand['icon'] === 'string') {
        icon = <img alt={`${brand.name ?? "Brand"} logo`} src={brand['icon']} className={'m-auto max-w-5 max-h-5'}/>;
    } else {
        icon = <FontAwesomeIcon icon={brand['icon'] ?? faQuestion} className={'m-auto max-w-5 max-h-5'}/>;
    }

    let sizeClass = {
        2: 'w-2 h-2 min-w-2 min-h-2',
        4: 'w-4 h-4 min-w-4 min-h-4',
        6: 'w-6 h-6 min-w-6 min-h-6',
        8: 'w-8 h-8 min-w-8 min-h-8',
        10: 'w-10 h-10 min-w-10 min-h-10',
    };


    return (<div className={
        "col-logo flex rounded-full my-auto" + ' ' + sizeClass[size] + ' ' + bg + ' ' + text + ' ' + className
    }>
        {icon}
    </div>);

}
